import { ButtonAsLink } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { readRichText } from "./return-step-heading";

type ReturnFlowErrorProps = {
  customerSupportInformation?: string;
};

export const ReturnFlowError = ({
  customerSupportInformation,
}: ReturnFlowErrorProps) => {
  const translate = useTranslate();
  const supportHtml = readRichText(customerSupportInformation);

  return (
    <div className="mt-component-spacing-3xl mb-component-spacing-5xl px-component-spacing-sm">
      <div className="mx-auto flex max-w-xl flex-col items-center gap-4 text-center">
        {supportHtml && (
          <div
            className="w-full text-left font-primary text-body-md text-black [&_p]:m-0"
            dangerouslySetInnerHTML={{ __html: supportHtml }}
          />
        )}
        <div className="mx-auto w-full max-w-[500px] pt-component-spacing-3xl">
          <ButtonAsLink
            label={translate("return_flow_success_homepage_button")}
            link={{ href: "" }}
            variants={{
              width: "full",
              rounded: "md",
              color: "black",
              size: "lg",
            }}
          />
        </div>
      </div>
    </div>
  );
};
